module.exports = __webpack_public_path__ + "assets/img/icon-cs.057dc4a3.png";